import React, { useEffect } from 'react'
import { isAndroid, isIOS } from 'react-device-detect';

export default function DineinRedirection() {
    useEffect(() => {
        let storeLink: any = isAndroid ? "https://play.google.com/store/apps/details?id=io.bramerz.kfc&hl=en&gl=US" : isIOS && "https://apps.apple.com/us/app/kfc-pakistan/id1480491422";
        window.location.replace(storeLink)
    }, [])
    return (
        <div></div>
    )
}
